import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { appTheme } from '../styles/theme';

const StatsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const StatItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.75rem;
  font-weight: 600;
  color: ${appTheme.textMuted};
`;

const LikeButton = styled.button<{ $liked: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0;
  border: none;
  background: none;
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  color: ${({ $liked }) => ($liked ? appTheme.green : appTheme.textMuted)};
  cursor: pointer;

  &:hover:not(:disabled) {
    color: ${appTheme.green};
  }

  &:focus-visible {
    outline: 2px solid ${appTheme.green};
    outline-offset: 2px;
    border-radius: ${appTheme.radiusSm};
  }

  &:disabled {
    cursor: wait;
    opacity: 0.7;
  }
`;

interface TemplateCardStatsProps {
  usageCount: number;
  likeCount: number;
  liked: boolean;
  liking?: boolean;
  onToggleLike: (event: React.MouseEvent) => void;
}

const TemplateCardStats: React.FC<TemplateCardStatsProps> = ({
  usageCount,
  likeCount,
  liked,
  liking = false,
  onToggleLike,
}) => {
  const { t } = useTranslation();

  return (
    <StatsRow>
      <StatItem aria-label={t('templates.carousel.usageCount', { count: usageCount })}>
        <span aria-hidden="true">↗</span>
        {t('templates.carousel.usageCount', { count: usageCount })}
      </StatItem>
      <LikeButton
        type="button"
        $liked={liked}
        disabled={liking}
        aria-pressed={liked}
        aria-label={t('templates.carousel.likeCount', { count: likeCount })}
        onClick={onToggleLike}
      >
        <span aria-hidden="true">{liked ? '♥' : '♡'}</span>
        {t('templates.carousel.likeCount', { count: likeCount })}
      </LikeButton>
    </StatsRow>
  );
};

export default TemplateCardStats;
